const dtoSchemas = {
  userRegisterApi: {
    fields: ['eventId', 'username'],
  },

  product: {
    fields: ['id', 'name', 'price', 'category', 'inStock'],
    defaults: {
      inStock: true,
      category: 'uncategorized'
    },
    transforms: {
      price: (value) => parseFloat(value) || 0
    }
  },

  post: {
    fields: ['id', 'title', 'content', 'author', 'createdAt'],
    defaults: {
      createdAt: () => new Date().toISOString()
    }
  },

  comment: {
    fields: ['id', 'postId', 'userId', 'text', 'timestamp'],
    defaults: {
      timestamp: () => Date.now()
    }
  }
};

/**
 * Tworzy obiekt DTO na podstawie zdefiniowanego schematu
 * @param {string} type - Typ DTO (np. 'user', 'product')
 * @param {object} sourceData - Dane źródłowe
 * @param {object} options - Opcjonalne ustawienia
 * @returns {object} Obiekt DTO
 */
export const createDTO = (type, sourceData = {}, options = {}) => {
  const schema = dtoSchemas[type];

  if (!schema) {
    throw new Error(`Nieznany typ DTO: ${type}`);
  }

  const dto = {};
  const { fields, defaults = {}, transforms = {} } = schema;
  const { validate = false } = options;

  // Przepisz tylko zdefiniowane pola
  fields.forEach(field => {
    let value = sourceData[field];

    // Użyj wartości domyślnej jeśli pole nie istnieje
    if (value === undefined && defaults[field] !== undefined) {
      value = typeof defaults[field] === 'function'
        ? defaults[field]()
        : defaults[field];
    }

    // Zastosuj transformację jeśli jest zdefiniowana
    if (transforms[field] && value !== undefined) {
      value = transforms[field](value);
    }

    // Dodaj pole do DTO tylko jeśli ma wartość
    if (value !== undefined) {
      dto[field] = value;
    }
  });

  // Opcjonalna walidacja
  if (validate) {
    const missingFields = fields.filter(field => dto[field] === undefined);
    if (missingFields.length > 0) {
      console.warn(`Brakujące pola w DTO ${type}:`, missingFields);
    }
  }

  return dto;
};
